import apis from '@/pages/activity-manage/proSalesData/apis';
export const PROSALESDATA_ACTINFO = 'PROSALESDATA_ACTINFO';
export const HAVE_RIGHT_TO_VIEW_ACTIVITY_DATA = 'haveRightToViewActivityData';
export const QUERY_ACTIVITY_LOADING = 'QUERY_ACTIVITY_LOADING';
export const RESET_PLAN_DATA = 'RESET_PLAN_DATA';

export const proSalesDataActInfo = (data) => (dispatch, getState) => {
  // const param = Object.assign(
  //   {},
  //   { startTime: data.startTime },
  //   { endTime: data.endTime },
  //   { plant: data.channel },
  //   { planCode: data.activityCode }
  // );
  dispatch({
    type: PROSALESDATA_ACTINFO,
    payload: initialState,
  });
  apis.proSalesDataActInfo(data).then((res) => {
    if (res && res.ret === '0') {
      dispatch({
        type: PROSALESDATA_ACTINFO,
        payload: res.data,
      });
    } else {
      dispatch({
        type: PROSALESDATA_ACTINFO,
        payload: initialState,
      });
    }
  });
};

export const resetPlanData = function () {
  return {
    type: 'RESET_PLAN_DATA',
  };
};
export const haveRightToViewActivityData = function (payload) {
  return {
    type: HAVE_RIGHT_TO_VIEW_ACTIVITY_DATA,
    payload,
  };
};

const initialState = {
  // 是否有查看当前活动的权限
  flowdata: [],
  summaryInfo: {},
  detailList: [],
};

export default function activityPlan(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case PROSALESDATA_ACTINFO:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
